import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'
import BotIcon from './BotIcon'

// Fun thinking phrases
const THINKING_PHRASES = [
  'decoding the matrix',
  'brewing brain-tea',
  'herding stray thoughts',
  'knitting neuron sweaters',
  'doing quantum hula-hoops',
  'juggling invisible ideas',
  'marinating in genius sauce',
  'tickling the data dragons',
  'running mental karaoke',
  'tuning her curiosity kazoo',
  'whispering to the algorithms',
  'polishing crystal ball bearings',
  'conducting a synapse symphony',
  'stir-frying the facts',
  'practicing mind yoga',
  'playing chess with squirrels',
  'picking the lock on wisdom',
  'spinning up a thought tornado',
  'baking byte-sized cookies',
  'moon-walking through memory lane',
  'wrangling rogue variables',
  'charging the pun capacitor'
]

const getRandomThinkingPhrase = () => {
  return THINKING_PHRASES[Math.floor(Math.random() * THINKING_PHRASES.length)]
}

const LoadingSpinner = ({ message = 'Loading...', size = 40, agentStyle = false, showIcon = true }) => {
  if (agentStyle) {
    return (
      <Box sx={{ textAlign: 'center', py: 6 }}>
        {showIcon && (
          <BotIcon 
            sx={{ 
              fontSize: 48, 
              color: 'secondary.main', 
              mb: 2,
            }} 
          />
        )}
        <Typography variant="h6" color="secondary.main" gutterBottom>
          Izzi is {getRandomThinkingPhrase()}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, mb: 1 }}>
          <Typography variant="body2" color="text.secondary">
            {message}
          </Typography>
          <Box sx={{ display: 'flex', gap: 0.3 }}>
            {[0, 1, 2].map((i) => (
              <Box
                key={i}
                sx={{
                  width: 8,
                  height: 8,
                  backgroundColor: 'text.secondary',
                  borderRadius: '50%',
                  animation: `typingDot 1.4s infinite ease-in-out`,
                  animationDelay: `${i * 0.16}s`,
                  '@keyframes typingDot': {
                    '0%, 80%, 100%': {
                      transform: 'scale(0.8)',
                      opacity: 0.5,
                    },
                    '40%': {
                      transform: 'scale(1)',
                      opacity: 1,
                    },
                  },
                }}
              />
            ))}
          </Box>
        </Box>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        minHeight: 200,
        gap: 2,
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          fontWeight: 400,
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
          fontSize: '0.9rem'
        }}
        gutterBottom
      >
        {message}
      </Typography>
      <Box sx={{ display: 'flex', gap: 0.3, mt: 1 }}>
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              width: 8,
              height: 8,
              backgroundColor: 'text.secondary',
              borderRadius: '50%',
              animation: `typingDot 1.4s infinite ease-in-out`,
              animationDelay: `${i * 0.16}s`,
              '@keyframes typingDot': {
                '0%, 80%, 100%': {
                  transform: 'scale(0.8)',
                  opacity: 0.5,
                },
                '40%': {
                  transform: 'scale(1)',
                  opacity: 1,
                },
              },
            }}
          />
        ))}
      </Box>
    </Box>
  )
}

export default LoadingSpinner